query getValueGraphInsights($input: ValueGraphInsightsInput) {
  getValueGraphInsights(input: $input) {
    insights {
      type
      displayName
      measureType
      description
      data {
        met
        detail
        ruleDetail
        value
        group {
          id
          name
        }
        objectives {
          id
          name
          type
          datasource {
            type
          }
          attributes {
            id
            attributeType
            subtype
            label
            value
          }
          parentObjectiveIds
        }
      }
    }
  }
}
